import { Select } from "antd";
import { useTranslation } from "react-i18next";

import { LANGUAGES_SELECT_OPTIONS } from "./LanguagePicker.constants";

function LanguagePicker() {
  const { i18n } = useTranslation();

  const handleOnChange = (value: string) => {
    i18n.changeLanguage(value);
  };

  return (
    <Select
      defaultValue={i18n.language}
      style={{
        width: 68,
        height: 32,
      }}
      onChange={handleOnChange}
      options={LANGUAGES_SELECT_OPTIONS}
    />
  );
}

export default LanguagePicker;
